import { useQuery } from '@tanstack/react-query';
import { apiGet, operationsClient } from '@/lib/api/client';
import { onboardingEndpoints } from '@/lib/api/endpoints';
import { onboardingKeys } from '@/lib/queryKeys';
import type { OnboardingStatus } from '@/types/onboarding';

/**
 * Shared fetcher — exported so the dashboard gate (`beforeLoad`) can prime the
 * cache via `queryClient.ensureQueryData()` and the page/banner can read the
 * same query without a second network call.
 */
export async function fetchOnboardingStatus(): Promise<OnboardingStatus> {
  return apiGet<OnboardingStatus>(operationsClient, onboardingEndpoints.status());
}

/**
 * @param enabled - gate the request so callers that can't/shouldn't show
 * onboarding (non-setup users, or the onboarding page itself) don't fire it on
 * every dashboard shell mount. Defaults to true.
 */
export function useOnboardingStatus(enabled = true) {
  return useQuery<OnboardingStatus>({
    queryKey: onboardingKeys.status(),
    queryFn: fetchOnboardingStatus,
    enabled,
  });
}
